import React from 'react';
import { TranslationView } from '@levelapp/softfabric-ui';
import { Text, View } from 'react-native';
import Project from '../../../../../Common/DTO/Project';
import ProjectBenefit from '../../../../../Common/DTO/ProjectBenefit';
import Helpers from '../../../../../Common/Helpers/AmountHelpers';
import {styles} from "./AdvantagesViewStyle";

interface AdvantagesViewProps {
  projectBenefits : ProjectBenefit[]
  project: Project
}

export const AdvantagesView = ({projectBenefits, project}:AdvantagesViewProps) => {

    if (projectBenefits.length === 0) return null;

    return (
      <View style={styles.page}>

        {project.code === 'rwdm' ? (
          <TranslationView style={styles.title}>reasonsToParticipate</TranslationView>
        ) : (
          <TranslationView style={styles.title}>reasonsToInvest</TranslationView>
        )}
        {projectBenefits.map((benefit: ProjectBenefit, index: number) => {
          return (
            <View key={index} style={styles.box}>
              <View style={styles.boxTitleView}>
                <Text style={styles.boxOrder}>{benefit.order}</Text>
                <Text style={styles.boxTitle}>{Helpers.getCorrectTranslation(benefit.title)}</Text>
              </View>
              <Text style={styles.boxText}>{Helpers.getCorrectTranslation(benefit.subtitle)}</Text>
            </View>
          )
        })}
      </View>
    );
}

export default AdvantagesView;